// Debug entry point that enables Angular DevTools support.
// enableDebugTools() registers window.ng.getComponent etc.
// which the Angular DevTools Chrome extension requires.
import { enableDebugTools } from '@angular/platform-browser';
import { bootstrapApplication } from '@angular/platform-browser';
import { ApplicationRef } from '@angular/core';
import logger from 'loglevel';

import { environment } from './environments/environment.js';
import { AppComponent } from './app/app.component.js';
import { appConfig } from './app/app.config.js';

if (environment.production) {
    throw new Error('Debug build should not run in production mode');
}

// logger.debug == logger.log
// TODO: start using logger.info and reduce this to INFO
logger.setLevel(logger.levels.DEBUG);

document.body.addEventListener('touchstart', () => document.body.classList.add('is-touch'));

bootstrapApplication(AppComponent, appConfig)
    .then((appRef: ApplicationRef) => {
        // enableDebugTools expects a ComponentRef, but bootstrapApplication returns ApplicationRef.
        // Get the root ComponentRef from the ApplicationRef.
        const rootComp = appRef.components[0];
        enableDebugTools(rootComp);
    })
    .catch(err => logger.log(err));
